import { createReducer, on } from '@ngrx/store';

import * as actions from '../actions/social-channels.action';
import { Membership, SocialChannel } from '../../models';
import { ToEntities } from '@teamfoster/sdk/array-utility';

export interface SocialChannelsState {
  entities: { [id: number]: SocialChannel };
  memberships: { [id: number]: Membership };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: SocialChannelsState = {
  entities: {},
  memberships: {},
  loaded: false,
  loading: false,
};

export const socialChannelsReducer = createReducer(
  initialState,
  on(actions.LoadSocialChannels, (state: SocialChannelsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.LoadSocialChannelsSuccess, (state: SocialChannelsState, { channels }) => {
    const entities = ToEntities(channels.socialChannels, 'id', {});
    const memberships = ToEntities(channels.memberships, 'id', {});
    return {
      ...state,
      entities,
      memberships,
      loading: false,
      loaded: true,
    };
  }),
  on(actions.LoadSocialChannelsFail, (state: SocialChannelsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getSocialChannelEntities = (state: SocialChannelsState) => state.entities;
export const getMembershipEntities = (state: SocialChannelsState) => state.memberships;
export const getSocialChannelsLoading = (state: SocialChannelsState) => state.loading;
export const getSocialChannelsLoaded = (state: SocialChannelsState) => state.loaded;
